export default "__VITE_ASSET__BH$rnrzz__"